"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateLong = void 0;
/*
 * Форматирует дату в формат DD MMMM YYYY (25 января 2020)
 *
 * @param {Date} date
 * */
const formatDateLong = date => date.toLocaleDateString('ru-RU', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}).slice(0, -3);
exports.formatDateLong = formatDateLong;